<template>
  <div class="signUp-container">
    <div class="signUp-header">
      <svg width="83" height="55" viewBox="0 0 83 55" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.736 39.6402L6.408 47.9282L9.048 39.6402H11.816L7.688 51.0002H5.112L0.952 39.6402H3.736ZM12.6613 41.6402V39.3202H15.2213V41.6402H12.6613ZM12.6613 51.0002V42.6002H15.2213V51.0002H12.6613ZM20.9738 51.1602C20.0138 51.1602 19.1978 50.9576 18.5258 50.5522C17.8644 50.1469 17.3578 49.6136 17.0058 48.9522C16.6538 48.2909 16.4778 47.5762 16.4778 46.8082C16.4778 46.0296 16.6538 45.3096 17.0058 44.6482C17.3578 43.9869 17.8698 43.4536 18.5418 43.0482C19.2138 42.6429 20.0244 42.4402 20.9738 42.4402C21.9231 42.4402 22.7338 42.6429 23.4058 43.0482C24.0778 43.4536 24.5898 43.9869 24.9418 44.6482C25.2938 45.3096 25.4698 46.0296 25.4698 46.8082C25.4698 47.5762 25.2938 48.2909 24.9418 48.9522C24.5898 49.6136 24.0778 50.1469 23.4058 50.5522C22.7338 50.9576 21.9231 51.1602 20.9738 51.1602ZM19.1018 46.8082C19.1018 47.4589 19.2778 47.9869 19.6298 48.3922C19.9924 48.7976 20.4404 49.0002 20.9738 49.0002C21.4964 49.0002 21.9338 48.7976 22.2858 48.3922C22.6484 47.9869 22.8298 47.4589 22.8298 46.8082C22.8298 46.1576 22.6484 45.6296 22.2858 45.2242C21.9338 44.8189 21.4964 44.6162 20.9738 44.6162C20.4404 44.6162 19.9924 44.8189 19.6298 45.2242C19.2778 45.6296 19.1018 46.1576 19.1018 46.8082ZM26.8068 51.0002V39.6402H29.4308V48.6962H34.9348V51.0002H26.8068ZM39.9429 51.1602C38.9935 51.1602 38.1829 50.9629 37.5109 50.5682C36.8389 50.1736 36.3215 49.6509 35.9589 49.0002C35.6069 48.3496 35.4309 47.6456 35.4309 46.8882C35.4309 46.0776 35.6069 45.3362 35.9589 44.6642C36.3109 43.9922 36.8229 43.4536 37.4949 43.0482C38.1669 42.6429 38.9829 42.4402 39.9429 42.4402C40.8922 42.4402 41.7029 42.6429 42.3749 43.0482C43.0469 43.4536 43.5535 43.9869 43.8949 44.6482C44.2469 45.3096 44.4229 46.0189 44.4229 46.7762C44.4229 47.0856 44.4015 47.3576 44.3589 47.5922H38.1509C38.1935 48.1576 38.3962 48.5896 38.7589 48.8882C39.1322 49.1762 39.5535 49.3202 40.0229 49.3202C40.3962 49.3202 40.7535 49.2296 41.0949 49.0482C41.4362 48.8669 41.6709 48.6216 41.7989 48.3122L43.9749 48.9202C43.6442 49.5816 43.1269 50.1202 42.4229 50.5362C41.7295 50.9522 40.9029 51.1602 39.9429 51.1602ZM38.0869 46.0242H41.7349C41.6815 45.4909 41.4842 45.0696 41.1429 44.7602C40.8122 44.4402 40.4015 44.2802 39.9109 44.2802C39.4202 44.2802 39.0042 44.4402 38.6629 44.7602C38.3322 45.0802 38.1402 45.5016 38.0869 46.0242ZM48.8471 51.0322C48.1005 51.0322 47.4498 50.8402 46.8951 50.4562C46.3405 50.0722 45.9031 49.5602 45.5831 48.9202C45.2738 48.2802 45.1191 47.5709 45.1191 46.7922C45.1191 45.9709 45.2845 45.2349 45.6151 44.5842C45.9458 43.9229 46.4045 43.4002 46.9911 43.0162C47.5778 42.6322 48.2551 42.4402 49.0231 42.4402C49.6525 42.4402 50.2071 42.5789 50.6871 42.8562C51.1671 43.1229 51.5511 43.4962 51.8391 43.9762V42.6002H54.0631V50.4242C54.0631 51.2776 53.8551 52.0136 53.4391 52.6322C53.0338 53.2509 52.4631 53.7256 51.7271 54.0562C51.0018 54.3976 50.1591 54.5682 49.1991 54.5682C48.3031 54.5682 47.5298 54.4189 46.8791 54.1202C46.2391 53.8322 45.6791 53.4216 45.1991 52.8882L46.5751 51.4962C46.8845 51.8482 47.2685 52.1256 47.7271 52.3282C48.1965 52.5416 48.6871 52.6482 49.1991 52.6482C49.6151 52.6482 49.9938 52.5736 50.3351 52.4242C50.6871 52.2749 50.9698 52.0349 51.1831 51.7042C51.3965 51.3842 51.5031 50.9576 51.5031 50.4242V49.6082C51.2471 50.0776 50.8738 50.4349 50.3831 50.6802C49.9031 50.9149 49.3911 51.0322 48.8471 51.0322ZM49.7271 49.0002C50.1218 49.0002 50.4738 48.8936 50.7831 48.6802C51.0925 48.4562 51.3325 48.1736 51.5031 47.8322V46.0722C51.3325 45.6349 51.0711 45.2829 50.7191 45.0162C50.3671 44.7496 49.9938 44.6162 49.5991 44.6162C49.2365 44.6162 48.9111 44.7229 48.6231 44.9362C48.3458 45.1389 48.1271 45.4109 47.9671 45.7522C47.8071 46.0936 47.7271 46.4616 47.7271 46.8562C47.7271 47.4749 47.9191 47.9869 48.3031 48.3922C48.6871 48.7976 49.1618 49.0002 49.7271 49.0002ZM55.2895 48.4882C55.2895 47.9336 55.4442 47.4482 55.7535 47.0322C56.0628 46.6162 56.4895 46.2909 57.0335 46.0562C57.5775 45.8109 58.2015 45.6882 58.9055 45.6882C59.2468 45.6882 59.5828 45.7202 59.9135 45.7842C60.2442 45.8376 60.5322 45.9176 60.7775 46.0242V45.6562C60.7775 44.7069 60.2175 44.2322 59.0975 44.2322C58.6282 44.2322 58.1855 44.3122 57.7695 44.4722C57.3642 44.6322 56.9322 44.8616 56.4735 45.1602L55.7055 43.5282C56.8148 42.8029 58.0308 42.4402 59.3535 42.4402C60.6122 42.4402 61.5882 42.7442 62.2815 43.3522C62.9855 43.9496 63.3375 44.8189 63.3375 45.9602V48.1522C63.3375 48.4082 63.3748 48.5896 63.4495 48.6962C63.5348 48.8029 63.6788 48.8616 63.8815 48.8722V51.0002C63.6575 51.0429 63.4548 51.0749 63.2735 51.0962C63.0922 51.1176 62.9322 51.1282 62.7935 51.1282C62.3135 51.1282 61.9455 51.0322 61.6895 50.8402C61.4442 50.6482 61.2895 50.3869 61.2255 50.0562L61.1775 49.6882C60.8042 50.1682 60.3562 50.5362 59.8335 50.7922C59.3108 51.0376 58.7722 51.1602 58.2175 51.1602C57.6628 51.1602 57.1615 51.0429 56.7135 50.8082C56.2762 50.5736 55.9295 50.2589 55.6735 49.8642C55.4175 49.4589 55.2895 49.0002 55.2895 48.4882ZM60.3775 48.8082C60.6442 48.5949 60.7775 48.3762 60.7775 48.1522V47.4002C60.5535 47.3149 60.3082 47.2509 60.0415 47.2082C59.7855 47.1549 59.5508 47.1282 59.3375 47.1282C58.8575 47.1282 58.4628 47.2349 58.1535 47.4482C57.8548 47.6616 57.7055 47.9336 57.7055 48.2642C57.7055 48.5522 57.8175 48.8029 58.0415 49.0162C58.2762 49.2189 58.5855 49.3202 58.9695 49.3202C59.2255 49.3202 59.4815 49.2722 59.7375 49.1762C59.9935 49.0802 60.2068 48.9576 60.3775 48.8082ZM69.2085 51.1602C68.2698 51.1602 67.4592 50.9576 66.7765 50.5522C66.1045 50.1469 65.5872 49.6136 65.2245 48.9522C64.8725 48.2909 64.6965 47.5709 64.6965 46.7922C64.6965 46.0242 64.8725 45.3096 65.2245 44.6482C65.5872 43.9869 66.1045 43.4536 66.7765 43.0482C67.4485 42.6429 68.2592 42.4402 69.2085 42.4402C70.1685 42.4402 70.9792 42.6482 71.6405 43.0642C72.3125 43.4696 72.8138 44.0029 73.1445 44.6642L70.6485 45.4162C70.3178 44.8829 69.8325 44.6162 69.1925 44.6162C68.6698 44.6162 68.2272 44.8136 67.8645 45.2082C67.5018 45.6029 67.3205 46.1309 67.3205 46.7922C67.3205 47.4536 67.5018 47.9869 67.8645 48.3922C68.2272 48.7976 68.6698 49.0002 69.1925 49.0002C69.5125 49.0002 69.8058 48.9256 70.0725 48.7762C70.3392 48.6162 70.5365 48.4136 70.6645 48.1682L73.1605 48.9362C72.8512 49.5869 72.3552 50.1202 71.6725 50.5362C71.0005 50.9522 70.1792 51.1602 69.2085 51.1602ZM74.2096 52.2642C74.647 52.4029 75.015 52.4722 75.3136 52.4722C75.6123 52.4722 75.847 52.3656 76.0176 52.1522C76.199 51.9389 76.359 51.5549 76.4976 51.0002L73.2976 42.6002H75.9376L77.8896 48.3762L79.5536 42.6002H81.9696L78.7696 52.3602C78.5456 53.0536 78.1403 53.6136 77.5536 54.0402C76.9776 54.4776 76.3003 54.6962 75.5216 54.6962C75.0736 54.6962 74.6363 54.6162 74.2096 54.4562V52.2642Z"
                                                                                                           fill="#8900E1">
      </path><circle cx="28.5" cy="5.82568" r="3.5"
                     fill="#8900E1">
      </circle><circle cx="57.5" cy="11.8254" r="3.5"
                       fill="#8900E1"></circle>
        <path d="M26.5 26.3257C25 24.8257 17 22.5 17 6L30 17.5L41 1.32568C41.3333 6.65902 41.5 20.3257 35.5 26.3257C34.1667 27.659 30.5 29.5257 26.5 26.3257Z"
              fill="#8900E1">
        </path><path d="M43.0001 12.8247C43.0001 2.82509 44.0003 1.32487 44.0003 1.32487L53.2543 19.0281L70.5712 24.6295C70.2854 25.4692 68.3353 26.1679 66.5625 26.8031L66.4999 26.8255C64.7107 27.4667 58.8438 28.1728 56.8438 28.1728L52.2187 28.1728L49.9999 28.1728C48.1875 28.1728 45.9999 27.4818 44.9999 26.0004C44.5072 25.2706 43 23.5002 42.9999 19.028L42.9999 16.0004L43.0001 12.8247Z"
                     fill="#8900E1">
        </path></svg>
    </div>
    <hr class="good-line" />
    <div class="back-top" id="opp-back-top" @click="handleBack">
      <div>
        <ion-icon name="arrow-back-outline" class="big-icon"></ion-icon>
      </div>
      <h2>Back</h2>
    </div>

    <ul class="progression">
      <li class="progression-item" @click="toBlock(0)">
        <h3 :class="{ violet: showBlock == 0 }">Basic Information</h3>
      </li>
      <li><ion-icon name="arrow-forward-outline"></ion-icon></li>
      <li class="progression-item" @click="toBlock(1)">
        <h3 :class="{ violet: showBlock == 1 }">About</h3>
      </li>
      <li><ion-icon name="arrow-forward-outline"></ion-icon></li>
      <li class="progression-item" @click="toBlock(2)">
        <h3 :class="{ violet: showBlock == 2 }">Experience</h3>
      </li>
    </ul>

    <form
      class="form"
      @submit.prevent="handleSubmit"
    >
      <div v-show="showBlock == 0" class="signUp-basic-info">
        <div class="basic-info-1st-line">
          <div class="first-item">
            <h4>First Name</h4>
            <h4 v-if="errors.firstName" class="warning">{{ errors.firstName }}</h4>
            <input @focusout="checkFirstName()" :class="{'error-input': errors.firstName != null }" type="text" v-model="firstName" required />
          </div>
          <div class="second-item">
            <h4>Last Name</h4>
            <h4 v-if="errors.lastName" class="warning">{{ errors.lastName }}</h4>
            <input @focusout="checkLastName()" :class="{'error-input': errors.lastName != null }" type="text" v-model="lastName" required />
          </div>
        </div>
        <h4>Email</h4>
        <h4 v-if="errors.email" class="warning">{{ errors.email }}</h4>
        <div :class="{'error-input': errors.email != null }" v-if="!isSenior" class="junior-email">
          <input
            @focusout="checkEmail()"
            type="text"
            v-model="email"
            placeholder="Your NetID"
            required
          />
          <p>@nyu.edu</p>
        </div>
        <input @focusout="checkEmail()" :class="{'error-input': errors.email != null }" v-if="isSenior" type="email" v-model="email" required />
        <h4>Password</h4>
        <h4 v-if="errors.password" class="warning">{{ errors.password }}</h4>
        <input @focusout="checkPassword()" :class="{'error-input': errors.password != null }" type="password" v-model="password" required />
        <h4>Confirm Password</h4>
        <h4 v-if="errors.confirmPassword" class="warning">{{ errors.confirmPassword }}</h4>
        <input
          :class="{'error-input': errors.confirmPassword != null }"
          type="password"
          @focusout="checkConfirmPassword()"
          v-model="cPassword"
          required
        />
        <h4>Career Track</h4>
        <h4 v-if="errors.careerTrack" class="warning">{{ errors.careerTrack }}</h4>
        <select
          @focusout="checkCareerTrack()"
          :class="{'error-input': errors.careerTrack != null }"
          name="careerTrack"
          id="careerTrack"
          v-model="careerTrack"
          required
        >
          <option value="default">Select your career track</option>
          <option value="Art & Design">Art & Design</option>
          <option value="Education & Training">Education & Training</option>
          <option value="Finance">Finance</option>
          <option value="Health & Pharmaceuticals">
            Health & Pharmaceuticals
          </option>
          <option value="Information Technology">Information Technology</option>
          <option value="Law & Government">Law & Government</option>
          <option value="Marketing">Marketing</option>
          <option value="Science & Engineering">Science & Engineering</option>
          <option value="Other">Other</option>
        </select>
        <h4>Major</h4>
        <h4 v-if="errors.major" class="warning">{{ errors.major }}</h4>
        <input @focusout="checkMajor()" :class="{'error-input': errors.major != null }" type="text" v-model="major" required />
        <h4>Cumulative GPA</h4>
        <h4 v-if="errors.gpa" class="warning">{{ errors.gpa }}</h4>
        <input @focusout="checkGPA()" :class="{'error-input': errors.gpa != null }" type="text" v-model="gpa" required />
        <h4>Graduation Year</h4>
        <h4 v-if="errors.year" class="warning">{{ errors.year }}</h4>
        <input @focusout="checkYear()" :class="{'error-input': errors.year != null }" type="number" v-model="year" required />
      </div>

      <div v-show="showBlock == 1">
        <h4>About</h4>
        <h4 v-if="errors.about" class="warning">{{ errors.about }}</h4>
        <textarea @focusout="checkAbout()" :class="{'error-input': errors.about != null }" v-model="about" required />

        <h4>Resume (Optional)</h4>
        <input
          class="input-file"
          type="file"
          id="input-resume"
          ref="resume"
          @change="changeTag"
        />
        <label class="input-file-label" for="input-resume">
          <ion-icon class="label-icon" name="cloud-upload-outline"></ion-icon>
          <p v-if="resumeTag">
            {{ resumeTag }}
          </p>
          <p v-else>Choose a file...</p>
        </label>

        <h4>Profile Picture (Optional)</h4>
        <input
          class="input-file"
          type="file"
          id="input-avatar"
          ref="profilePic"
          @change="changeTag"
        />
        <label class="input-file-label" for="input-avatar">
          <ion-icon class="label-icon" name="cloud-upload-outline"></ion-icon>
          <p v-if="profilePicTag">
            {{ profilePicTag }}
          </p>
          <p v-else>Choose a picture...</p>
        </label>
      </div>

      <div v-show="showBlock == 2" class="signUp-experience">
        <div class="signUp-experiences">
          <div v-for="exp in exps" :key="exp.id" class="experience-template">
            <div class="job-header">
              <hr />
              <h3>Job {{ exp.id }}</h3>
              <hr />
            </div>
            <h4>Job Title</h4>
            <input type="text" v-model="exp.title" required />
            <h4>Company</h4>
            <input type="text" v-model="exp.company" required />
            <div class="checkbox">
              <input
                type="checkbox"
                v-model="exp.currentInRole"
                id="current-in-role"
              />
              <h4>I am currently working on this role.</h4>
            </div>
            <div class="start-end">
              <div class="start-date date-template">
                <h4>Start Date</h4>
                <input type="date" v-model="exp.startDate" required />
              </div>
              <div class="end-date date-template">
                <h4>End Date</h4>
                <input
                  v-if="!exp.currentInRole"
                  type="date"
                  v-model="exp.endDate"
                  required
                />
                <div v-else id="present-box">
                  <h3 id="in-roll-text">Present</h3>
                </div>
              </div>
            </div>
            <h4>Description(Optional)</h4>
            <textarea v-model="exp.description" />
          </div>
        </div>
        <div v-if="exps.length == 0" class="default-exp">
          <h3>You haven't added any experience in your profile.</h3>
          <button @click="handleAddJob">Start adding your experiences</button>
        </div>
        <div class="addAndDelete">
          <button
            v-if="exps.length == 1"
            @click.prevent="handleAddJob"
            class="add-another-job"
          >
            Add Another Job
          </button>
          <div class="empty-block">
            <p v-if="exps.length == 2">
              You can show at most two of your experiences.
            </p>
          </div>
          <button
            v-if="exps.length > 0"
            @click.prevent="handleDeleteJob"
            class="delete-job"
          >
            Delete Job
          </button>
        </div>
      </div>

      <div class="step-btns">
        <button
          v-if="showBlock != 0"
          type="button"
          class="next-step"
          id="previous-step-btn"
          @click.prevent="prevPage"
        >
          Previous Step
        </button>
        <button
          v-if="showBlock != 2"
          type="button"
          class="next-step"
          id="next-step-btn"
          @click.prevent="nextPage"
        >
          Next Step
        </button>
      </div>

      <button
        v-if="showBlock == 2"
        type="submit"
        class="next-step"
        id="sign-up-btn"
      >
        Sign Up
      </button>
    </form>
  </div>
</template>

<script>
import { ref, watchEffect } from "vue";
import { useRouter } from "vue-router";
import firebase from "firebase/app";
import "firebase/firestore";
import useSignUp from "@/composables/useSignUp";
import sendWelcomeEmail from "@/composables/Email/sendWelcomeEmail";

export default {
  name: "SignUp",
  setup() {
    const router = useRouter();
    const { error, signUp } = useSignUp();
    const showBlock = ref(0);
    const errors = ref({
      firstName: null,
      lastName: null,
      email: null,
      password: null,
      confirmPassword: null,
      careerTrack: null,
      major: null,
      gpa: null,
      year: null,
      about: null
    });
    const isSenior = ref(false);
    const firstName = ref("");
    const lastName = ref("");
    const email = ref("");
    const password = ref("");
    const cPassword = ref("");
    const passwordMatch = ref(true);
    const careerTrack = ref("default");
    const major = ref("");
    const gpa = ref("");
    const year = ref("");
    const about = ref("");
    const resume = ref(null);
    const profilePic = ref(null);
    const resumeTag = ref(null);
    const profilePicTag = ref(null);
    const exps = ref([
      {
        id: 1,
        title: null,
        company: null,
        currentInRole: false,
        startDate: null,
        endDate: null,
        description: null,
      },
    ]);

    const changeTag = () => {
      if (resume.value.files[0]) {
        resumeTag.value = resume.value.files[0].name;
      }
      if (profilePic.value.files[0]) {
        profilePicTag.value = profilePic.value.files[0].name;
      }
    };

    const modifyExps = () => {
      const result = exps.value.map((exp) => {
        const startDateArr = exp.startDate.split("-");
        let startDateMod = new Date(
          startDateArr[0],
          startDateArr[1] - 1,
          startDateArr[2]
        );
        startDateMod = new firebase.firestore.Timestamp.fromDate(
          startDateMod
        ).toDate();
        let endDateMod;
        if (!exp.currentInRole) {
          const endDateArr = exp.endDate.split("-");
          endDateMod = new Date(
            endDateArr[0],
            endDateArr[1] - 1,
            endDateArr[2]
          );
          endDateMod = new firebase.firestore.Timestamp.fromDate(
            endDateMod
          ).toDate();
        } else {
          endDateMod = null;
        }
        return {
          ...exp,
          startDate: startDateMod,
          endDate: endDateMod,
        };
      });
      return result;
    };

    const modifyEmail = () => {
      if (isSenior.value) {
        return email.value;
      } else {
        return email.value + "@nyu.edu";
      }
    };

      checkCareerTrack
      checkMajor
      checkGPA
      checkYear

    const checkFirstName = () => {
      if (firstName.value == ""){
        errors.value.firstName = "Please enter your First Name."
      }
      else{
        errors.value.firstName = null
      }
    };

    const checkLastName = () => {
      if (lastName.value == ""){
        errors.value.lastName = "Please enter your Last Name."
      }
      else{
        errors.value.lastName = null
      }
    };

    const checkEmail = () => {
      if (email.value == ""){
        errors.value.email = "Please enter your Email."
      }
      else if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(modifyEmail()))) {
        errors.value.email = "Please enter a valid email address."
      }
      else{
        errors.value.email = null
      }
    };

    const checkPassword = () => {
      if (password.value == ""){
        errors.value.password = "Please enter your Password."
      }
      else if (password.value.length < 8){
        errors.value.password = "Your Password length must be greater than 8 characters."
      }
      else if (password.value.length > 20){
        errors.value.password = "Your Password length must be less than 20 characters."
      }
      else if (!(/^(?=.*\d)(?=.*[A-Za-z]).{8,20}$/.test(password.value))){
        errors.value.password = "Your Password contain a combination of letters and numbers."
      }
      else{
        errors.value.password = null
      }
    };

    const checkConfirmPassword = () => {
      if (cPassword.value == ""){
        errors.value.confirmPassword = "Please confirm your Password."
      }
      else if(password.value != cPassword.value) {
        errors.value.confirmPassword = "Your Password and Confirmation Password do not match."
      }
      else{
        errors.value.confirmPassword = null
      }
    };

    const checkCareerTrack = () => {
      if (careerTrack.value == "default"){
        errors.value.careerTrack = "Please select your Career Track."
      }
      else{
        errors.value.careerTrack = null
      }
    };

    const checkMajor = () => {
      if (major.value == ""){
        errors.value.major = "Please enter your Major."
      }
      else{
        errors.value.major = null
      }
    };

    const checkGPA = () => {
      if (gpa.value == ""){
        errors.value.gpa = "Please enter your Cumulative GPA."
      }
      else if(!((parseFloat(gpa.value) && parseFloat(gpa.value) <= 4 && parseFloat(gpa.value) >= 0))) {
        errors.value.gpa = "Your Cumulative GPA must be a numerical number between 0 and 4."
      }
      else{
        errors.value.gpa = null
      }
    };

    const checkYear = () => {
      if (year.value == ""){
        errors.value.year = "Please enter your Graduation Year."
      }
      else if(!(Number.isInteger(parseFloat(year.value)) && /^\d{4}$/.test(parseFloat(year.value)))) {
        errors.value.year = "Your Graduation must be a four-digit number."
      }
      else{
        errors.value.year = null
      }
    };

    const checkAbout = () => {
      if (about.value == ""){
        errors.value.about = "Please enter your Self-Description."
      }
      else{
        errors.value.about = null
      }
    };

    const handleBack = () => {
      router.go(-1);
    };

    const handleSubmit = async () => {
      await signUp(modifyEmail(), password.value, {
        isSenior: isSenior.value,
        firstName: firstName.value,
        lastName: lastName.value,
        email: modifyEmail(),
        major: major.value,
        company: "default",
        gpa: gpa.value,
        year: year.value,
        careerTrack: careerTrack.value,
        about: about.value,
        resume: resume.value,
        profilePic: profilePic.value,
        experience: modifyExps(),
      });
      if (!error.value) {
        if (isSenior.value) {
          router.push({ name: "Senior-Dashboard" });
          sendWelcomeEmail(
            firstName.value + " " + lastName.value,
            modifyEmail()
          );
        } else {
          router.push({ name: "Verification" });
        }
      }
    };
    const toBlock = (num) => {
      if (num < showBlock.value) {
        showBlock.value = num;
      } else {
        if (num == 1 && checkEntry(0)) {
          showBlock.value = num;
        } else if (num == 2 && checkEntry(0) && checkEntry(1)) {
          showBlock.value = num;
        } else {
          alert("All fields must be correctly filled.");
        }
      }
    };
    const nextPage = () => {
      toBlock(showBlock.value + 1);
    };
    const prevPage = () => {
      toBlock(showBlock.value - 1);
    };
    const checkErrors = (page) => {
      switch (page) {
        case 0:
          checkFirstName();
          checkLastName();
          checkEmail();
          checkPassword();
          checkConfirmPassword();
          checkCareerTrack();
          checkMajor();
          checkGPA();
          checkYear();
          break;
        case 1:
          checkAbout()
          break;
      }
    }
    const checkEntry = (page) => {
      checkErrors(page)
      switch (page) {
        case 0:

          if (
            !errors.value.firstName &&
            !errors.value.lastName &&
            !errors.value.email &&
            !errors.value.password &&
            !errors.value.confirmPassword &&
            !errors.value.careerTrack &&
            !errors.value.major &&
            !errors.value.year
          ) {
            return true;
          }
          break;
        case 1:
          if (!errors.value.about) {
            return true;
          }
          break;
      }
      return false;
    };

    const handleAddJob = () => {
      exps.value.push({
        id: exps.value.length + 1,
        title: null,
        company: null,
        currentInRole: false,
        startDate: null,
        endDate: null,
        description: null,
      });
    };

    const handleDeleteJob = () => {
      if (exps.value.length > 0) {
        exps.value.pop();
      }
    };

    return {
      errors,
      showBlock,
      isSenior,
      firstName,
      lastName,
      email,
      password,
      cPassword,
      passwordMatch,
      careerTrack,
      major,
      gpa,
      year,
      about,
      resume,
      profilePic,
      resumeTag,
      profilePicTag,
      exps,
      handleBack,
      handleSubmit,
      nextPage,
      prevPage,
      checkEntry,
      handleAddJob,
      handleDeleteJob,
      toBlock,
      checkFirstName,
      checkLastName,
      checkEmail,
      checkPassword,
      checkConfirmPassword,
      checkCareerTrack,
      checkMajor,
      checkGPA,
      checkYear,
      checkAbout,
      changeTag,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.signUp-container {
  margin: 4vh 15vw;
  margin-bottom: 6vh;
}

.error-input{
  border-color: red !important;
}

.signUp-header {
  display: flex;
  padding: 0 0 10px 2vw;
  align-items: center;
}

.signUp-header img {
  height: 4vh;
}

.signUp-header div {
  flex: 0 1 20%;
  margin-right: 1vw;
}

.signUp-small-container {
  opacity: 1;
  background-color: white;
  display: flex;
  margin: 0 15vw;
  align-items: center;
  flex-direction: column;
  padding: 3vh;
}

.progression {
  width: 50vw;
  list-style: none;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  margin-bottom: 5vh;
  flex: 0 1 auto;
}

.progression li {
  margin-right: 2vw;
  align-items: center;
}

.progression-item:hover {
  cursor: pointer;
  color: grey;
}

.basic-info {
  margin-top: 7vh;
}

.basic-info ul {
  list-style: none;
  align-items: center;
}

.basic-info-1st-line {
  margin: 0 auto;
  width: 50%;
  display: flex;
}

.junior-email {
  display: flex;
  width: 50%;
  font-size: 120%;
  margin: 1vh auto;
  margin-bottom: 2vh;
  outline: none;
  border: 2px var(--purple-l) solid;
  border-radius: 20px;
  height: 35px;
}

.junior-email input {
  padding-right: 0;
  flex: 1 1 auto;
  height: 30px;
  background: rgba(255, 255, 255, 0);
  font-size: 100%;
  display: inline-block;
  border: none;
  margin: 0;
}

.junior-email p {
  height: 31px;
  padding-top: 2px;
  padding-right: 1vw;
  flex: 0 0 auto;
  display: inline-block;
}

#careerTrack {
  display: block;
  width: 50%;
  font-size: 120%;
  margin: 1vh auto;
  margin-bottom: 2vh;
  padding: 0 1vw;
  outline: none;
  border: 2px var(--purple-l) solid;
  border-radius: 20px;
  height: 35px;
}

.input-file {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

.input-file-label {
  margin-left: 25%;
  padding: 0.5vh 0.5vw;
  font-size: 75%;
  text-align: center;
  color: var(--purple-l);
}

.input-file-label p {
  display: inline;
}

.input-file-label:hover {
  cursor: pointer;
  border-bottom: 1px #cca2d8 solid;
}

.label-icon {
  font-size: 150%;
  width: 30px;
  height: 30px;
  vertical-align: middle;
  fill: currentColor;
  margin-top: -0.25em;
  margin-right: 0.25em;
}

.first-item {
  width: 14vw;
  flex: 1 0 45%;
  margin-right: 10%;
}

.second-item {
  width: 14vw;
  flex: 1 0 45%;
}

.first-item input,
.second-item input {
  margin-top: 1vh;
  margin-bottom: 1vh;
  border: 2px var(--purple-l) solid;
  border-radius: 20px;
  height: 35px;
  width: 100%;
}

.first-item h4,
.second-item h4 {
  width: 100%;
}

.step-btns {
  width: 50vw;
  justify-content: center;
  display: flex;
  margin: 0 auto;
}

.next-step {
  margin: 0 1vw;
  margin-top: 2vh;
  border: none;
  background-color: var(--purple-l);
  color: white;
  font-weight: bold;
  font-size: 100%;
  padding: 1vh 0vw;
  width: 10vw;
  min-width: 100px;
  border-radius: 30px;
  transition: 0.3s ease-out;
}

.next-step:hover {
  background-color: var(--purple);
  padding: 1vh 0vw;
  cursor: pointer;
}

.soloBtn {
  margin-left: 0;
}

#sign-up-btn {
  display: block;
  margin: 35px auto;
  font-size: 150%;
  width: 15vw;
  padding: 1vh 0;
}

.job-header {
  width: 50%;
  margin: 0 auto;
  height: 2vh;
  display: flex;
  margin-bottom: 1vh;
  margin-top: 5vh;
  align-items: center;
}

.job-header hr {
  display: table-cell;
  flex: 0 1 40%;
  height: 0px;
}

.job-header h3 {
  flex: 1 0 auto;
  text-align: center;
}

.checkbox {
  width: 50%;
  margin: 0 auto;
  display: flex;
  align-items: center;
}

.checkbox input {
  flex: 0 1 10%;
  height: 25px;
  width: 25px;
  left: 495px;
  top: 421px;
  color: #cca2d8;
}

.checkbox input:checked {
  background-color: #cca2d8;
}

.checkbox h4 {
  flex: 1 0 auto;
}

.start-end {
  width: 50%;
  margin: 0 auto;
  display: flex;
}

.start-date {
  margin-right: 5%;
}

.date-template {
  flex: 1 0 45%;
}

.date-template h4 {
  width: 100%;
  margin-bottom: 1vh;
}

#present-box {
  height: 4vh;
}

#in-roll-text {
  height: 4vh;
  display: table-cell;
  vertical-align: middle;
}

.date-template input {
  width: 14vw;
}

.addAndDelete {
  display: flex;
  width: 50%;
  margin: 0 auto;
}

.add-another-job {
  flex: 0 1 auto;
  text-align: left;
  display: inline-block;
  padding: 0.5vh 1vw;
  border-radius: 1.5vh;
  border: 1.5px #cca2d8 solid;
  background-color: transparent;
  color: #cca2d8;
}

.add-another-job:hover {
  border-color: #c47cd8;
  color: #c47cd8;
  cursor: pointer;
}

.empty-block {
  flex: 1 0 auto;
}

.empty-block p {
  font-size: 80%;
}

.delete-job {
  flex: 0 1 auto;
  text-align: right;
  display: inline-block;
  border: none;
  background-color: transparent;
  color: #cca2d8;
}

.delete-job:hover {
  color: #c47cd8;
  text-decoration: underline;
  cursor: pointer;
}

.default-exp {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.default-exp h3 {
  text-align: center;
  vertical-align: middle;
  margin: 8vh 0 4vh 0;
}

.default-exp button {
  text-align: center;
  vertical-align: middle;
  margin-bottom: 15vh;
  padding: 2vh 4vh;
  color: white;
  font-size: 120%;
  font-weight: 500;
  background-color: #cca2d8;
  border-radius: 4vh;
  border: none;
}

.default-exp button:hover {
  background-color: #c069d8;
  cursor: pointer;
}
</style>
